<template>
    <div class="col-12">
        <h4 class="bg-success p-2">Bloco I - Famílias</h4>
        <table class="table table-bordered">
            <tr>
                <th>A.1.</th>
                <td>Total de famílias Cadastradas – Inserido Manualmente</td>
                <td>{{ dados.total_familia_inserida_manualmente }}</td>
            </tr>
            <tr>
                <th>A.2.</th>
                <td>Total de famílias Cadastradas – Importadas do CadÚnico</td>
                <td>{{ dados.total_familias_importadas_cadunico }}</td>
            </tr>
            <tr>
                <th>A.3</th>
                <td>Famílias em acompanhamento ativo</td>
                <td>{{ dados.total_familias_acompanhemnto }}</td>
            </tr>
            <tr>
                <th>A.4.</th>
                <td>Novas famílias inseridas em Acompanhamento</td>
                <td>{{ dados.total_familias_novas_acompanhemnto }}</td>
            </tr>
            <tr>
                <th>A.5</th>
                <td>
                    Famílias com cadastro básico – pessoa em situação de rua
                </td>
                <td>{{ dados.total_familias_situacao_rua }}</td>
            </tr>
        </table>

        <h4 class="bg-success p-2">BLOCO 2 – SERVIÇOS/INTERVENÇÕES</h4>
        <table class="table table-bordered">
            <tr>
                <th>B.1</th>
                <th colspan="2">Atendimento</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Atendimentos realizados – Unidades do SUAS</td>
                <td>{{ dados.total_atendimentos_realizados }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">b)Atendimentos realizados por tipo</th>
                <th>
                    {{
                        dados.total_atendimentos_por_tipo.total
                    }}
                </th>
            </tr>

            <tr v-for="(item, i) in dados.total_atendimentos_por_tipo.dados" :key="i">
                <td colspan="2">{{ item.descricao }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">c)Atendimento realizado por local</th>
                <th>
                    {{
                        dados.total_atendimentos_por_local
                            ? dados.total_atendimentos_por_local.reduce(
                                  (soma, item) => {
                                      return soma + item.total;
                                  },
                                  0
                              )
                            : ""
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_atendimentos_por_local"
                :key="i"
            >
                <td colspan="2">{{ item.local_nome }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>d)</th>
                <td>Atendimentos registrados como privativo</td>
                <td>{{ dados.total_atendimentos_privados }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">B.1.1 Atendimento por Unidade</th>
                <th>
                    {{
                        dados.total_atendimentos_por_unidades
                            ? dados.total_atendimentos_por_unidades.reduce(
                                  (soma, item) => {
                                      return soma + item.total;
                                  },
                                  0
                              )
                            : ""
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_atendimentos_por_unidades"
                :key="i"
            >
                <td colspan="2">{{ item.nome }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>B.2</th>
                <th colspan="2">Encaminhamento</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Encaminhamentos realizados</td>
                <td>{{ dados.total_encaminhamento_realizados }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">b) Encaminhamento realizado por tipo</th>
                <th>
                    {{
                        dados.total_encaminhamento_por_tipo
                            ? dados.total_encaminhamento_por_tipo.total
                            : 0
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_encaminhamento_por_tipo.dados"
                :key="i"
            >
                <td colspan="2">{{ item.descricao }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">c) Encaminhamentos por Unidade de Destino</th>
                <th>
                    {{
                        dados.total_encaminhamento_por_unidades_destino
                            ? dados.total_encaminhamento_por_unidades_destino.reduce(
                                  (soma, item) => {
                                      return soma + item.total;
                                  },
                                  0
                              )
                            : ""
                    }}
                </th>
            </tr>

            <tr
                v-for="(
                    item, i
                ) in dados.total_encaminhamento_por_unidades_destino"
                :key="i"
            >
                <td colspan="2">{{ item.nome }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">
                    B.2.1 Encaminhamentos por Unidade
                </th>
                <th>
                    {{
                        dados.total_encaminhamento_por_unidades
                            ? dados.total_encaminhamento_por_unidades.reduce(
                                  (soma, item) => {
                                      return soma + item.total;
                                  },
                                  0
                              )
                            : ""
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_encaminhamento_por_unidades"
                :key="i"
            >
                <td colspan="2">{{ item.nome }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>B.3</th>
                <th colspan="2">Referência e Contrarreferência</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Número de Referência Realizados</td>
                <td>{{ dados.total_referencia_realizada }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">
                    b) Número de Referência Realizados por Unidade
                </th>
                <th>
                    {{
                        dados.total_referencia_por_unidades
                            ? dados.total_referencia_por_unidades.reduce(
                                  (soma, item) => {
                                      return soma + item.total;
                                  },
                                  0
                              )
                            : ""
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_referencia_por_unidades"
                :key="i"
            >
                <td colspan="2">{{ item.nome }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>c)</th>
                <td>Número de Contrarreferência Realizados</td>
                <td>{{ dados.total_contrareferencia_realizada }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">
                    d) Número de Contrarreferência Realizados por Unidade
                </th>
                <th>
                    {{
                        dados.total_contrareferencia_por_unidades
                            ? dados.total_contrareferencia_por_unidades.reduce(
                                  (soma, item) => {
                                      return soma + item.total;
                                  },
                                  0
                              )
                            : ""
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_contrareferencia_por_unidades"
                :key="i"
            >
                <td colspan="2">{{ item.nome }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>B.4</th>
                <th colspan="2">Medidas Socioeducativas</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Medidas socioeducativas registradas</td>
                <td>{{ dados.total_medidas_realizada }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">b) Medidas socioeducativas por tipo</th>
                <th>
                    {{
                        dados.total_medidas_por_tipo
                            ? dados.total_medidas_por_tipo.total
                            : 0
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_medidas_por_tipo.dados"
                :key="i"
            >
                <td colspan="2">{{ item.descricao }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>
        <table class="table table-bordered">
            <tr>
                <th>B.5</th>
                <th colspan="2">Violação de Direitos</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Número de registros de Violação de Direitos</td>
                <td>{{ dados.total_violacao_realizada }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">
                    b) Registro de Violação de Direitos por tipo
                </th>
                <th>
                    {{
                        dados.total_violacao_por_tipo.total
                    }}
                </th>
            </tr>

            <tr v-for="(item, i) in dados.total_violacao_por_tipo.dados" :key="i">
                <td colspan="2">{{ item.tipo }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>B.6</th>
                <th colspan="2">Benefícios</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Número de benefícios eventuais concedidos</td>
                <td>{{ dados.total_beneficios_concedidos }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">
                    b) Benefícios Eventuais concedidos por modalidade
                </th>
                <th>
                    {{
                        dados.total_beneficios_concedidos_tipo.total
                    }}
                </th>
            </tr>

            <tr
                v-for="(item, i) in dados.total_beneficios_concedidos_tipo.dados"
                :key="i"
            >
                <td colspan="2">{{ item.tipo }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>c)</th>
                <td>Beneficios eventuais – parecer favorável</td>
                <td>{{ dados.total_beneficios_favoravel }}</td>
            </tr>
            <tr>
                <th>d)</th>
                <td>Benefícios eventuais – parecer desfavorável</td>
                <td>{{ dados.total_beneficios_desfavoravel }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">
                    e) Benefícios eventuais concedidos por Unidade
                </th>
                <th>
                    {{
                        dados.total_beneficios_unidade.total
                    }}
                </th>
            </tr>

            <tr v-for="(item, i) in dados.total_beneficios_unidade.dados" :key="i">
                <td colspan="2">{{ item.tipo }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="3">
                    f) Benefícios eventuais concedidos por unidade/modalidade
                </th>
            </tr>
        </table>

        <table
            class="table table-bordered"
            v-for="(itens, unidade) in dados.total_beneficios_unidade_tipo"
            :key="unidade"
        >
            <thead>
                <tr>
                    <th colspan="2">{{ unidade }}</th>
                    <th>
                        {{
                            itens
                                ? itens.reduce((soma, item) => soma + Number(item.total || 0), 0)
                                : 0
                        }}
                    </th>
                </tr>
                <tr>
                    <th colspan="2">Tipo de benefício</th>
                    <th>Total</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(item, index) in itens" :key="index">
                    <td colspan="2">{{ item.tipo }}</td>
                    <td>{{ item.total }}</td>
                </tr>
            </tbody>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>B.7</th>
                <th colspan="2">Acolhimento</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Usuários em situação de acolhimento</td>
                <td>{{ dados.total_acolhimento }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="2">
                    b) Usuários em situação de acolhimento por unidade
                </th>
                <th>
                    {{
                        dados.total_acolhimento_unidade.total
                    }}
                </th>
            </tr>

            <tr v-for="(item, i) in dados.total_acolhimento_unidade.dados" :key="i">
                <td colspan="2">{{ item.tipo }}</td>
                <td>{{ item.total }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="3">
                    c) Número de vagas disponíveis e ocupadas por unidade de
                    Acolhimento
                </th>
            </tr>

            <tr v-for="(item, i) in dados.total_acolhimento_vagas" :key="i">
                <th>{{ item.unidade_nome }}</th>
                <td>
                    Disponíveis : <b>{{ item.vagas_disponiveis }}</b>
                </td>
                <td>
                    Ocupadas: <b>{{ item.vagas_ocupadas }}</b>
                </td>
            </tr>
        </table>

        <h4 class="bg-success p-2">BLOCO – Ações Diversas</h4>
        <table class="table table-bordered">
            <tr>
                <th>C.1.</th>
                <th colspan="2">Ofícios</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Número de ofícios emitidos</td>
                <td>{{ dados.total_oficios_emitidos }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="3">b) Número de ofícios emitidos por unidade</th>
            </tr>

            <tr v-for="(item, i) in dados.total_oficios_unidades" :key="i">
                <th>{{ item.tipo }}</th>
                <td>
                    {{ item.total }}
                </td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>C.2.</th>
                <th colspan="2">Denúncias</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Denúncias registradas</td>
                <td>{{ dados.total_denuncias }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>b) Registro de denúncias por canal de recebimento</th>
                <th>
                    {{
                        dados.total_denuncias_canal.total
                    }}
                </th>
            </tr>

            <tr v-for="(item, i) in dados.total_denuncias_canal.dados" :key="i">
                <th>{{ item.tipo }}</th>
                <td>
                    {{ item.total }}
                </td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>c) Registros por tipo de denunciante</th>
                <th>
                    {{
                        dados.total_denuncias_tipo.total
                    }}
                </th>
            </tr>
            <tr v-for="(item, i) in dados.total_denuncias_tipo.dados" :key="i">
                <th>{{ item.tipo }}</th>
                <td>
                    {{ item.total }}
                </td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>C.3</th>
                <th colspan="2">Atividades</th>
            </tr>
            <tr>
                <th>a)</th>
                <td>Atividades Cadastradas</td>
                <td>{{ dados.total_atividades }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>b) Atividades Cadastradas por tipo</th>
                <th>
                    {{
                        dados.total_atividades_tipo
                            ? dados.total_atividades_tipo.total : 0
                    }}
                </th>
            </tr>
            <tr v-for="(item, i) in dados.total_atividades_tipo.dados" :key="i">
                <th>{{ item.descricao }}</th>
                <td>
                    {{ item.total }}
                </td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="3">c) Atividades Cadastradas por tipo/unidade</th>
            </tr>

            <tr
                v-for="(itens, i) in dados.total_atividades_unidade_tipo"
                :key="i"
            >
                <table class="table table-bordered mb-0">
                    <tr>
                        <th colspan="2">{{ i }}</th>
                        <th>
                            {{
                                itens
                                    ? itens.reduce((soma, item) => {
                                          return soma + item.total;
                                      }, 0)
                                    : ""
                            }}
                        </th>
                    </tr>
                    <tr v-for="(item, b) in itens" :key="b">
                        <td colspan="2">{{ item.descricao }}</td>
                        <td>{{ item.total }}</td>
                    </tr>
                </table>
            </tr>
        </table>

        <h4 class="bg-success p-2">BLOCO – SCFV</h4>
        <table class="table table-bordered">
            <tr>
                <th>D.1.</th>
                <td>Número de grupos ativos do SCFV</td>
                <td>{{ dados.total_grupos_ativos_SCFV }}</td>
            </tr>
            <tr>
                <th>D.2.</th>
                <td>Número de usuários ativos no SCFV</td>
                <td>{{ dados.total_pessoas_SCFV }}</td>
            </tr>
            <tr>
                <th>D.3.</th>
                <td>Número de novos usuários ativos no SCFV no período</td>
                <td>{{ dados.total_pessoas_periodo_SCFV }}</td>
            </tr>
            <tr>
                <th>D.4.</th>
                <td>Atividades cadastradas</td>
                <td>{{ dados.total_atividades_SCFV }}</td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="3">D.5 Atividades cadastradas por grupo</th>
            </tr>

            <tr
                v-for="(itens, i) in dados.total_atividades_grupo_SCFV"
                :key="i"
            >
                <table class="table table-bordered mb-0">
                    <tr>
                        <th>GRUPO: {{ i }}</th>
                        <th>
                            {{
                                itens
                                    ? itens.reduce((soma, item) => {
                                          return soma + item.total;
                                      }, 0)
                                    : ""
                            }}
                        </th>
                    </tr>
                    <tr v-for="(item, b) in itens" :key="b">
                        <td>{{ item.tema }}</td>
                        <td>{{ item.total }}</td>
                    </tr>
                </table>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th>D.6. Atividades cadastradas por tipo</th>
                <th>
                    {{
                        dados.total_atividades_tipo_SCFV
                            ? dados.total_atividades_tipo_SCFV.total : 0
                    }}
                </th>
            </tr>
            <tr v-for="(item, i) in dados.total_atividades_tipo_SCFV.dados" :key="i">
                <td>{{ item.descricao }}</td>
                <td>
                    {{ item.total }}
                </td>
            </tr>
        </table>

        <table class="table table-bordered">
            <tr>
                <th colspan="3">D.7 Atividades cadastradas por unidade/tipo</th>
            </tr>

            <tr
                v-for="(itens, i) in dados.total_atividades_unidade_tipo_SCFV"
                :key="i"
            >
                <table class="table table-bordered mb-0">
                    <tr>
                        <th colspan="2">Unidade: {{ i }}</th>
                        <th>
                            {{
                                itens
                                    ? itens.reduce((soma, item) => {
                                          return soma + item.total;
                                      }, 0)
                                    : ""
                            }}
                        </th>
                    </tr>
                    <tr v-for="(item, b) in itens" :key="b">
                        <td colspan="2">{{ item.descricao }}</td>
                        <td>{{ item.total }}</td>
                    </tr>
                </table>
            </tr>
        </table>

        <!-- <p>
            <b class="text-danger">Atenção!</b> Quando a abordagem é feita a um
            grupo, cada pessoa do grupo é contada como uma abordagem.
        </p>
        <h4 v-if="footer != false">
            Nome e cargo da pessoa responsável no CREAS pelas informações:
        </h4> -->
        <div v-if="footer != false" class="row px-3 mt-4">
            <div class="col-8 pl-0 border-bottom">Assinatura:</div>
            <div class="col-4 border-bottom">CPF:</div>
        </div>

        <div class="footer_impressao">
            <div v-if="tecnico">
                <span><strong>Técnico responsável:</strong> {{ tecnico.nome }}</span>
                <span v-if="tecnico.profissao"><strong>Cargo:</strong> {{ tecnico.profissao }}</span>
                <span><strong>Data/Hora da emissão:</strong> {{ dataHoraAtual }}</span>
            </div>
        </div>

    </div>
</template>

<style>

    .footer_impressao {
        display: none;
    }

    /* Se quiser que apareça apenas na impressão */
    @media print {
        .footer_impressao {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background: white;
            border-top: 1px solid #ccc;
            padding: 8px 20px;
            font-size: 14px;
        }
    }

    /* Adiciona o separador " - " automaticamente entre os spans */
    .footer_impressao span:not(:last-child)::after {
        content: " - ";
        margin: 0 5px;
    }

</style>

<script>
export default {
    name: "RMA_CRAS",
    props: ["mes", "ano", "periodo", "dados", "header", "footer"],
    data() {
        return {
            unidadeSelected: "",
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
            tecnico: null,
            dataHoraAtual: null,
        };
    },
    watch: {
        // unidade() {
        // 	tdis.getUnidade();
        // },
    },
    mounted() {
        this.getTecnico();
        this.definirDataHoraAtual();
    },
    metdods: {
        getUnidade() {
            axios
                .get(`api/dashboard/unidades/${this.unidade}`)
                .then((response) => {
                    this.unidadeSelected = response.data.data;
                });
        },
        verifyValue(value) {
            return value == 0 || value == "0" ? "" : value;
        },
        getTecnico() {
            const userId = this.$store.state.user.id;

            axios.get(`/api/dashboard/tecnico/get/user_id/${userId}`).then((response) => {
                this.tecnico = response.data.data;
            })
            .catch((error) => {
                console.error("Erro ao buscar técnico:", error);
            });
        },
        definirDataHoraAtual() {
            const agora = new Date();
            const dataFormatada = agora.toLocaleDateString("pt-BR");
            const horaFormatada = agora.toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit",
            });
            this.dataHoraAtual = `${dataFormatada} ${horaFormatada}`;
        },
    },
};
</script>
<style>
.router-link-exact-active {
    cursor: pointer;
}
</style>
